<template>
  <div>
    <div style="margin-bottom: 15px;">
      <el-button @click="returnParent" size="mini" icon="Top" v-if="upper_path">上一层 </el-button>
    </div>
    <div class="table_container" v-loading="is_loading">

      <table>
        <thead>
          <tr>
            <th style="width: 50px;padding: 8px 0;text-align: center;">选择</th>
            <th>文件名称</th>
            <th>文件大小</th>
            <th>类型</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tree_table_datas" :key="item.id">
            <td style="text-align: center;">
              <el-checkbox size="large" v-model="item.is_select" label="" @change="selectItem(item)">
                <span>
                  <el-icon v-if="item.type == 'dir'" title="文件夹">
                    <Folder />
                  </el-icon>
                  <el-icon v-if="item.type == 'file'" title="文件">
                    <Document />
                  </el-icon>
                </span>
              </el-checkbox>
            </td>
            <td>
              <el-text v-if="item.type == 'file'">{{ item.label }}</el-text>
              <el-text v-if="item.type == 'dir'" type="primary" style="cursor: pointer;color: var(--theme-color);"
                @click="getNextLayerData(item)">{{
                item.label }}</el-text>
            </td>
            <td>{{ item.filesize }}</td>
            <td>{{ item.type }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import { ElMessage } from 'element-plus';
  import { get_data_center_data } from '@/api/index.js';
  const emit = defineEmits(['updataSelected'])
  const props = defineProps({
    personal_data: {
      type: Object
    }
  });

  const is_loading = ref(false);//是否正在加载
  const tree_table_datas = ref(null);//树形表格数据
  const selectedItemId = ref(null);//选中的节点id
  const current_path = ref(null);//当前路径
  const upper_path = ref(null);//上一级路径
  const outermost_layer_path = ref(null);//最外层路径


  const getMyData = function (path) { //获取数据
    path ? handleUpperPath(path) : upper_path.value = null;
    is_loading.value = true;
    get_data_center_data({ path: path }).then((result) => {
      const list = result.data.map(item => {
        return { ...item, is_select: false };
      });
      tree_table_datas.value = list;
      current_path.value = result.dir || null;
      if (!path) outermost_layer_path.value = result.dir;//初始最外层路径
      is_loading.value = false;
    }).catch((err) => {
      console.error(err);
      is_loading.value = false;
    });
  };

  const handleUpperPath = function (path) { //处理上一级路径
    const pathParts = path.split('/'); //分割路径
    pathParts.pop();//删除最后一项
    const parentDir = pathParts.join('/');
    upper_path.value = parentDir;
  };

  const isArrayWithData = function (data) { //判断数组是否有数据
    return Array.isArray(data) && data.length > 0;
  };

  const checkFun = function (item) { //判断是否选中
    tree_table_datas.value.forEach(element => {
      if (item.id === element.id && item.is_select) {
        element.is_select = true;
        selectedItemId.value = item.dir;
      } else {
        element.is_select = false;
      }
    });
    emit('updataSelected', selectedItemId.value);
  };

  const selectItem = function (item) { //选中节点
    const { file_whitelist } = props.personal_data;//文件百白名单
    const is_array = isArrayWithData(file_whitelist);
    if (is_array) {
      const type_name = item.label;
      let fileName1 = type_name.substring(type_name.lastIndexOf('.') + 1).toUpperCase();
      let fileName2 = type_name.substring(type_name.lastIndexOf('.', type_name.lastIndexOf('.') - 1) + 1).toUpperCase();
      let is_select = false;
      for (let i = 0; i < file_whitelist.length; i++) {
        const element = file_whitelist[i].toUpperCase();
        if (element.includes(fileName1) && fileName2.includes(element)) {
          is_select = true;
          break;
        }
      };
      setTimeout(() => {
        if (is_select) {
          checkFun(item);
        } else {
          ElMessage.warning('此文件不支持选择！');
          item.is_select = false;
        };
      }, 300);
    } else {
      checkFun(item);
    };
  };

  const getNextLayerData = function (item) { //获取下一层数据
    if (item.type == 'dir') getMyData(item.dir);
  };

  const returnParent = function () { //返回上一级
    if (!upper_path.value) return false;
    if (upper_path.value == outermost_layer_path.value) {
      upper_path.value = null;
      getMyData(upper_path.value);
      return;
    }
    getMyData(upper_path.value);
  };

  // 使用 watch 监听 props 的字段变化
  watch(() => props, (newData, oldData) => {
  });
  //组件即将挂载
  onBeforeMount(() => {
  });
  //组件已经挂载
  onMounted(() => {
    getMyData(null);
  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
  });
  //组件已经卸载
  onUnmounted(() => {
  });
</script>
<style scoped>
  table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;

  }

  th,
  td {
    text-align: left;
    border: 1px solid var(--el-border-color);
    padding: 3px;
  }
</style>